module.exports = __webpack_public_path__ + "static/media/banner_bg.1d769927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_bg.jpg
// module id = 2090
// module chunks = 7